/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Search from "../../../Common/Search";
import Sorting from "../../../Common/Sorting";
import {
  sortingNameList,
  verifyValues,
} from "../../../../utilities/enums/index";
import { connect } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";
import Paginations from "../../../Common/Pagination";
import ReviewTable from "../../../Tables/ReviewTable";
import { reviewList } from "../../../../stores/actions/review.actions.types";

const ReviewList = (props) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [reviews, setReviews] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [sorting, setSorting] = useState([
    {
      whom: "updatedAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    getReviewList(search, pagination.page, sorting, status);
  }, [search, sorting, pagination.page, status]);

  const getReviewList = (q = search, page, sort, status) => {
    const callback = (data) => {
      if (data.success) {
        const { total, pages, reviews } = data?.data;
        setPagination((prev) => ({
          ...prev,
          total: total || 0,
          pages: pages || 1,
        }));
        setReviews(reviews);
      }
    };

    let request = {
      callback,
      data: { q, page, sort, verified: status },
    };
    props.reviewList(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  const handleChangeStatus = (value) => {
    setStatus(value);
  };

  return (
    <div>
      <MetaHead title={t("Review List")} />
      <div className='flex flex-col sm:flex-row justify-end mb-3 gap-2'>
        <Search
          search={search}
          placeholder='Search by product name'
          setSearch={setSearch}
        />

        {/* <RoleSorting
          name={"Select Role"}
          roles={roles}
          onChange={handleChangeRole}
        /> */}
        <Sorting
          name={"Status"}
          values={verifyValues}
          onChange={handleChangeStatus}
        />
        <Sorting
          name={"Sort"}
          values={sortingNameList}
          onChange={handleChangeSorting}
        />
        {/* <div>
          <NavLink
            className='flex items-center justify-center h-8 border text-lg border-red-600 px-3 text-red-600'
            to='/user/add'
          >
            <FaPlus />
          </NavLink>
        </div> */}
      </div>
      {props.loading ? (
        <div className='flex dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : (
        <div>
          <ReviewTable reviews={reviews} setReviews={setReviews} />
          <Paginations pagination={pagination} setPagination={setPagination} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});
export default connect(mapStateToProps, {
  reviewList,
})(ReviewList);
